







import Vue from 'vue';

export default Vue.extend({
  name: 'CardImage',
  props: {
    src: String,
    size: {
      type: Number,
      default: 80,
    },
  },
  computed: {
    classes() {
      return [
        this.src ? '' : 'no-src',
      ];
    },
  },
});
